function calculateNicotineStrength() {
    var cigarettes = document.getElementById("cigarettes").value;
    var result = document.getElementById("result");
    
    if (cigarettes == 0) {
        result.innerHTML = "<span>😊</span>Recommended Nicotine Strength: <strong style='color: #C71231;'>0mg</strong>";
    } else if (cigarettes <= 5) {
        result.innerHTML = "<span>😃</span>Recommended Nicotine Strength: <strong style='color: #C71231;'>3mg</strong>";
    } else if (cigarettes <= 10) {
        result.innerHTML = "<span>😄</span>Recommended Nicotine Strength: <strong style='color: #C71231;'>6mg</strong>";
    } else if (cigarettes <= 20) {
        result.innerHTML = "<span>😅</span>Recommended Nicotine Strength: <strong style='color: #C71231;'>12mg</strong>";
    } else {
        result.innerHTML = "<span>😆</span>Recommended Nicotine Strength: <strong style='color: #C71231;'>18mg</strong>";
    }
}
